import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { VENDOR_PROOFREADER_COMMENT_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { vendorProofreaderCommentFailure, vendorProofreaderCommentSuccess } from '../actions';

const VendorResolveProofreaderAPI = (action) => postApiRequest(VENDOR_PROOFREADER_COMMENT_API_URL, action);

function* handleVendorResolveProofreader(action) {
  try {
    const response = yield call(VendorResolveProofreaderAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(vendorProofreaderCommentSuccess(response));
  } catch (error) {
    yield put(vendorProofreaderCommentFailure(error));
  }
}

export function* watchVendorResolveProofreader() {
  yield takeLatest(types.VENDOR_PROOFREADER_COMMENT_REQUEST, handleVendorResolveProofreader);
}
